import React, {Component} from 'react';
import {connect} from 'react-redux'
import {
    AppBar,
    Card,
    CardContent,
    Toolbar,
    Typography,
    TextField,
    Button, Grid,
} from '@material-ui/core';
import {withRouter} from "react-router-dom";
import moment from "moment";
import {bindActionCreators} from "redux";
import ReduxMission from "../../../../../store/actionreducers/mission";
import ReduxGlobal from "../../../../../store/actionreducers/globalView"

class ModifyReservedTimeTab extends Component {

    state = {
        reservationDefault: '',
        date: '',
        startTime: '',
        endTime: '',
    }

    componentDidMount() {
        const { tempMission } = this.props;
        const reservationDate = tempMission.reservation_mission.date
        const reservationDateString = moment(reservationDate).format("YYYY-MM-DD")
        const reservationStartTime = tempMission.reservation_mission.start_time
        const reservationEndTime = tempMission.reservation_mission.end_time

        this.setState({
            date: reservationDateString,
            startTime: reservationStartTime,
            endTime: reservationEndTime,
        })
    }

    handleChange = (e) => {
        const target = e.target
        const name = target.name
        this.setState({
            [name]: target.value,
        });
      };

    updateTime = () => {
        const { date, startTime, endTime } = this.state
        const { tempMission, user } = this.props
        const reservationMissionId = tempMission.reservation_mission.id

        const { modifyReservationTime, modifyReservationTimeForAm, openAlertDialog, openLoadingMask, closeLoadingMask } = this.props

        if (startTime >= endTime) {
            openAlertDialog({
                title: '錯誤',
                message: '【起始時間】不能晚於【結束時間】',
                yesButton: {
                    label: '了解',
                },
                noButton: {
                    label: ''
                }
            })
        } else {
            openAlertDialog({
                title: '更改預約時間',
                message: '請問您確定要變更嗎?',
                yesButton: {
                    label: '是',
                    onClick: async () => {
                        try {
                            openLoadingMask();
                            const params = {
                                reservationMissionId,
                                date,
                                startTime: startTime + ':00',
                                endTime: endTime + ':00',
                            }

                            if (user) {
                                if (user.fk_role_id === 3) {
                                    await modifyReservationTime(params)
                                } else if (user.fk_role_id === 1) {
                                    await modifyReservationTimeForAm(params)
                                }
                            }

                            closeLoadingMask();
                        } catch (e) {
                            console.warn('you got an error = ', e);
                        }
                    },
                },
                noButton: {
                    label: '否'
                }
            })
        }
    }

    render() {
        const { date, startTime, endTime } = this.state

        return (
            <div>
                <Card className="w-full mb-16">
                    <AppBar position="static" elevation={0}>
                        <Toolbar className="pl-16 pr-8">
                            <Typography variant="subheading" color="inherit" className="flex-1">
                                預約時間
                            </Typography>
                        </Toolbar>
                    </AppBar>

                    <CardContent className='mb-24'>
                        <Grid container spacing={8}>
                            <Grid container item xs={4}>
                                <TextField
                                    label={'預約時間'}
                                    name={'date'}
                                    type={'date'}
                                    value={date}
                                    onChange={this.handleChange}/>
                            </Grid>
                            <Grid container item xs={4}>
                                <TextField
                                    label={'開始時間'}
                                    name={'startTime'}
                                    type={'time'}
                                    value={startTime}
                                    onChange={this.handleChange}/>
                            </Grid>
                            <Grid container item xs={4}>
                                <TextField
                                    label={'結束時間'}
                                    name={'endTime'}
                                    type={'time'}
                                    value={endTime}
                                    onChange={this.handleChange}/>
                            </Grid>
                            <Grid container item xs={4}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={this.updateTime}
                                >
                                    更改
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </div>
        );
    }
}

function mapStateToProps({ auth: { user}, mission: { temp: tempMission }, mission }) {
    return {
        tempMission,
        mission,
        user,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        modifyReservationTime: ReduxMission.ActionCreator.modifyReservationTime,
        modifyReservationTimeForAm: ReduxMission.ActionCreator.modifyReservationTimeForAm,
        openAlertDialog: ReduxGlobal.ActionCreator.openAlertDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ModifyReservedTimeTab));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/mission/tabs/ModifyReservedTimeTab.js